const noModalPages = ['page-cartPage'];

export const shouldSkipModal = () => {
	return noModalPages?.some(pageClass =>
		document.body.classList.contains(pageClass),
	);
};

export const addToCartSkipModal = () => {
	if (!document.body.classList.contains('page-cartPage')) return;
	setTimeout(() => {
		window.location.reload();
	}, 0);
};
